/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface InpyVersion
 */
export interface InpyVersion {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  threediVersion: string;
  /**
   *
   */
  threedicoreVersion: string;
  /**
   *
   */
  readonly slug?: string;
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  active?: boolean;
}

/**
 * Check if a given object implements the InpyVersion interface.
 */
export function instanceOfInpyVersion(value: object): value is InpyVersion {
  if (
    (!("threediVersion" in (value as Record<string, any>)) &&
      !("threedi_version" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["threediVersion"] === undefined &&
      (value as Record<string, any>)["threedi_version"] === undefined)
  )
    return false;
  if (
    (!("threedicoreVersion" in (value as Record<string, any>)) &&
      !("threedicore_version" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["threedicoreVersion"] === undefined &&
      (value as Record<string, any>)["threedicore_version"] === undefined)
  )
    return false;
  return true;
}

export function InpyVersionFromJSON(json: any): InpyVersion {
  return InpyVersionFromJSONTyped(json, false);
}

export function InpyVersionFromJSONTyped(json: any, ignoreDiscriminator: boolean): InpyVersion {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    threediVersion: json["threedi_version"],
    threedicoreVersion: json["threedicore_version"],
    slug: json["slug"] == null ? undefined : json["slug"],
    id: json["id"] == null ? undefined : json["id"],
    active: json["active"] == null ? undefined : json["active"],
  };
}

export function InpyVersionToJSON(json: any): InpyVersion {
  return InpyVersionToJSONTyped(json, false);
}

export function InpyVersionToJSONTyped(
  value?: Omit<InpyVersion, "url" | "slug" | "id"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    threedi_version: value["threediVersion"],
    threedicore_version: value["threedicoreVersion"],
    active: value["active"],
  };
}
